import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EventMessage } from './event-messaging.types';

@Injectable()
export class EventMessagingService {
	private messagingUrl = (eventId: number) => `api/events/${eventId}/messages`;

	constructor(private _http: HttpClient) { }

	sendMessage(eventId: number, message: EventMessage): Promise<void> {
		return this._http.post<void>(this.messagingUrl(eventId), message).toPromise();
	}
}
